exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chartPie[data-v-20044f64]{width:1.6rem;height:1.6rem;margin:0 auto}.chartPie.hot[data-v-20044f64]{width:.96rem;height:.96rem;margin:.05rem auto 0}", ""]);
